import React from 'react';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => {
  return (
    <div className="terms-and-conditions">
      <section className="page-title centred">
        <div className="bg-layer" style={{ backgroundImage: 'url(assets/img/bg-img.png)' }}></div>
        <div className="line-box">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>
        <div className="auto-container">
          <div className="content-box">
            <h1>Terms And Conditions</h1>
            <ul className="bread-crumb clearfix">
              <li><Link to="/">Home</Link></li>
              <li>Terms And Conditions</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="service-details industries-details">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12 content-side">
              <div className="service-details-content">
                <div className="content-three">
                  <div className="upper-box">
                    <h3>Terms And Conditions</h3>
                    <p>
                      These Terms and Conditions (“Terms”) set forth the legally binding terms governing your access to and use of the websites WWW.VWIMPEX.COM and their respective content. This notice applies to the VW IMPEX WEBSITE listed above, including official corporate websites, which are all collectively referred to as the “Website”. The Website is subject to the following terms and conditions, which set forth the legally binding terms for your use of the Website.
                    </p>
                  </div>
                  <div className="tabs-box">
                    <div className="tab-btn-box">
                      <div className="bg-layer" style={{ backgroundImage: 'url(assets/images/background/history-bg.jpg)' }}></div>
                      <ul className="tab-btns tab-buttons clearfix">
                        <li className="tab-btn active-btn" data-tab="#tab-1">Mandatory Arbitration<i className="flaticon-diagonal-arrow"></i></li>
                        <li className="tab-btn" data-tab="#tab-2">Changes to Terms<i className="flaticon-diagonal-arrow"></i></li>
                        <li className="tab-btn" data-tab="#tab-3">Intellectual Property<i className="flaticon-diagonal-arrow"></i></li>
                      </ul>
                    </div>
                    <div className="tabs-content">
                      <div className="tab active-tab" id="tab-1">
                        <div className="inner-box">
                          <div className="title-box">
                            <h3>Mandatory Arbitration</h3>
                          </div>
                          <div className="text">
                            <p>These Terms include an agreement to mandatory arbitration in certain situations. This means that any dispute related to these Terms or the Website must be resolved through binding individual arbitration rather than in court. The arbitration provision also includes waivers of class action and jury trial rights.</p>
                          </div>
                        </div>
                      </div>
                      <div className="tab" id="tab-2">
                        <div className="inner-box">
                          <div className="title-box">
                            <h3>Changes to Terms</h3>
                          </div>
                          <div className="text">
                            <p>SNKB Berings reserves the right to update or modify these Terms at any time without prior notice. Your continued use of the Website after any changes signifies your acceptance of the modified Terms.</p>
                          </div>
                        </div>
                      </div>
                      <div className="tab" id="tab-3">
                        <div className="inner-box">
                          <div className="title-box">
                            <h3>Intellectual Property</h3>
                          </div>
                          <div className="text">
                            <p>All content on the Website, including text, graphics, logos, images, and software, is the property of SNKB Berings or its licensors and is protected by copyright, trademark, and other laws. You may not use, reproduce, modify, or distribute any content from the Website without prior written consent.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
